import React from 'react';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Breadcrumb navigation component
 * @param {Object[]} items - Array of breadcrumb items
 * @param {string} items[].label - Display text
 * @param {string} [items[].path] - Navigation path (optional for last item)
 */
const Breadcrumb = ({ items = [] }) => {
  const { theme } = useTheme();
  const navigate = useNavigate();

  if (!items || items.length === 0) return null;

  return (
    <nav className="flex items-center gap-x-1 text-sm overflow-x-auto">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <React.Fragment key={index}>
            {index > 0 && (
              <ChevronRight className={`w-4 h-4 flex-shrink-0 ${theme.textMuted}`} />
            )}
            {isLast ? (
              <span className={`font-semibold ${theme.text} truncate max-w-[200px] sm:max-w-none`}>
                {item.label}
              </span>
            ) : (
              <button
                onClick={() => item.path && navigate(item.path)}
                className={`${theme.textMuted} hover:${theme.text} hover:underline transition-colors whitespace-nowrap`}
              >
                {item.label}
              </button>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
